// Polyfills for older browsers (iOS 16 / Safari 16)
import 'promise.withresolvers/auto';
import '@oddbird/popover-polyfill';
import '@/utils/requestIdleCallback.polyfill';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './index.scss';
import './signatureColors.scss';
import '@/utils/i18next';
import '@/utils/dayjs';
import '@/utils/popoverPosition';

const getApplicationEnvironment = () => {
  switch (window.location.host) {
    case 'app.swipesign.io':
      return 'production';
    case 'staging.swipesign.io':
      return 'staging';
    case 'test.swipesign.io':
      return 'test';
    default:
      return 'local';
  }
};

const appEnv = getApplicationEnvironment();

if (appEnv !== 'local') {
  Sentry.init({
    dsn: 'https://b1f3026e5917672da071f1d3c90d1aa7@o4508760917999616.ingest.de.sentry.io/4509112676646992',
    environment: appEnv,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

document.getElementById('boot')?.remove();
